import { PageSectionsServiceLinks } from '@/tina/__generated__/types';
import * as stylex from '@stylexjs/stylex';
import Image from 'next/image';
import { tinaField } from 'tinacms/dist/react';
import { layout } from '../../styles/layout';
import '../../styles/tokens.stylex';
import { borderRadius, color, shadow, spacing } from '../../styles/tokens.stylex';
import { typography } from '../../styles/typography';
import { Action, ActionButtons } from '../Buttons/ActionButtons';
import { PageSection } from '../PageSection';
import { RichText } from '../RichText';
import { ControlledLinkButton, ServiceLinkProvider } from './controlledLinkButtonProvider';
interface ServiceLinksProps {
  data: PageSectionsServiceLinks;
}
export function ServiceLinks({
  data
}: ServiceLinksProps) {
  return data.serviceCards ? <PageSection>
      <ul className="x1ghz6dp x1717udv x1mhrlx8 xe8uvvx xrvj5dj x1bs3opv xzo4163 x1p9eum2 x5kiwsz">
        {data.serviceCards.map((service, i) => {
        if (service) {
          const key = `${i}-${service.serviceName?.split(/ /g).join('-')}`;
          return <ServiceLinkProvider key={key} styles={[{
            "x-default-marker": "x-default-marker",
            $$css: true
          }, layout.contentCard, sx.serviceCard]}>
                <article className="x623te4 x171aqo1 xrvj5dj x4w6khx x1clt5hq">
                  <div className="x1o4oh2x x16pmaob x623te4 x1pte3vf xrvj5dj x4w6khx x1clt5hq">
                    <h1 {...stylex.props([typography.heading1, sx.heading])}>
                      {service.serviceName}
                    </h1>
                    <RichText wrapperStyles={sx.description}>
                      {service.serviceDescription}
                    </RichText>
                    {service.linkButton && <div className="x16pmaob x623te4 xjej8gk xrvj5dj x4w6khx x6ec99f">
                        <ControlledLinkButton centerTextBlock iconLeft={service.linkButton.iconLeft} href={`/${service.linkButton.topLevelPageLink?._sys.filename}`} data-tina-field={tinaField(service.linkButton, 'linkLabel')} styles={sx.action}>
                          {service.linkButton.linkLabel}
                        </ControlledLinkButton>
                        {service.ctaButton && <ActionButtons actions={[service.ctaButton] as Action[]} styles={sx.action} args={{
                    componentName: service.__typename
                  }} />}
                      </div>}
                  </div>
                  {service.image && <div className="x623te4 x7giv3 xm5cv13 x1clqncf x1n2onr6 x1leh1l0 xgqtt45">
                      <Image className="xgsjgxe xl1xv1r x1c071of x1gp2gou x1g0ag68 x1so62im" alt={service.alt} src={service.image} fill sizes="320px, (min-width: 420px) 400px, (min-width: 800px) 420px, (min-width: 1200px) 768px" />
                    </div>}
                </article>
              </ServiceLinkProvider>;
        }
        return null;
      })}
      </ul>
    </PageSection> : null;
}
const LAYOUT_S = '@container (min-width: 680px) and (max-width: 800px)';
const LAYOUT_M = '@container (min-width: 800px) and (max-width: 1360px)';
const LAYOUT_L = '@container (min-width: 1360px)';
const sx = {
  serviceCard: {
    kmVPX3: "xxef0ux",
    kaIpWk: "x1o5z2k8",
    kOIVth: "x167x4rx",
    kBCFzs: "x623te4",
    kbNqZ1: "x171aqo1",
    kWkggS: "x1xlpcrp xrzbrjk",
    kGVxlE: "x1xt9a6s",
    k1xSpc: "xrvj5dj",
    kumcoG: "x4w6khx",
    k9llMU: "x1clt5hq",
    $$css: true
  },
  heading: {
    kBCFzs: "x623te4",
    kN2L0X: "x1w2vvpw",
    $$css: true
  },
  description: {
    kBCFzs: "x623te4",
    kN2L0X: "x1fzhlzt",
    k1K539: "xat24cr",
    $$css: true
  },
  action: {
    kBCFzs: "x1ri595y x14ibdfw x1g6bjm9 x623te4",
    kbNqZ1: "x1ki88ai x12pxdt1 xt5x3x2 x1y9cxpo",
    $$css: true
  }
};